import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';
import * as Events from '../lib/events';

export default (el, props) => {
    const $el = $(el);
    let flkty;
    const $navButton = $el.find('[data-slider-nav]');
    const setHeight = props ? props.setHeight : true;
    const $indexNumber = $el.find('[data-slider-index]');
    const galleryTrigger = $el.find('[data-gallery-trigger]');
    const startIndex = parseInt(galleryTrigger.data('gallery-trigger'), 10);
    let doEmit = false;

    function onNavClick() {
        if ($(this).data('slider-nav') === 'next') {
            flkty.next();
        } else {
            flkty.previous();
        }
    }

    const onNext = (key, val) => {
        flkty.select(val);
    };

    const onPrev = (key, val) => {
        flkty.select(val);
    };

    const onSelect = (key, val) => {
        doEmit = false;
        flkty.select(val);
        doEmit = true;
    };

    const init = () => {
        flkty = new Flickity(el, {
            cellSelector: '[data-slide]',
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            dragThreshold: 10,
            cellAlign: 'center',
            setGallerySize: setHeight,
            percentPosition: true,
            accessibility: true
        });

        if (props !== null && props.hasIndex) {
            doEmit = true;
            Dispatch.on(Events.SLIDE_INDEX, onSelect);
            // Dispatch.on(Events.SLIDE_NEXT, onNext);
            // Dispatch.on(Events.SLIDE_PREV, onPrev);
        }

        if ($navButton.length) {
            $navButton.on('click', onNavClick);
        }

        flkty.on('select', () => {
            if (doEmit) {
                Dispatch.emit(Events.SLIDE_SELECT, flkty.selectedIndex);
            }

            if ($indexNumber.length) {
                $indexNumber.html(flkty.selectedIndex + 1);
            }

            galleryTrigger.data('gallery-trigger', startIndex + flkty.selectedIndex);
        });
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Slider.js